import React from 'react';
import { connect } from 'react-redux';
// Popup imports
import { PopupTypes } from './Enums';
import { CloseActivePopup } from '../../actions/popupActions';
import LevelSettingsModeEnum from './Types/LevelSettings/enums';
// Popup type imports
import Save from './Types/save';
import Publish from './Types/publish';
import NoWebGL from './Types/noWebGL';
import FailedLoad from './Types/failedLoad';
import LevelSettings from './Types/LevelSettings';
import LevelRemoveWarning from './Types/levelRemoveWarning';

class Popup extends React.Component {
    getActivePopupContent = (activeType, properties) => {
        switch (activeType) {
            case PopupTypes.SAVE: {
                return <Save properties={properties} />;
            }
            case PopupTypes.PUBLISH: {
                return <Publish properties={properties} />;
            }
            case PopupTypes.NOWEBGL: {
                return <NoWebGL properties={properties} />;
            }
            case PopupTypes.FAILEDLOAD: {
                return <FailedLoad properties={properties} />;
            }
            case PopupTypes.LEVEL_SETTINGS: {
                return <LevelSettings properties={properties} />;
            }
            case PopupTypes.LEVEL_REMOVE_WARNING: {
                return <LevelRemoveWarning properties={properties} />
            }
            default: {
                return <h1>Onbekende melding</h1>;
            }
        }
    };

    getCloseButton = (activeType, state) => {
        // Level settings doesn't need a close button
        switch (activeType) {
            case PopupTypes.SAVE:
            case PopupTypes.LEVEL_SETTINGS: 
            case PopupTypes.LEVEL_REMOVE_WARNING: {
                return <></>;
            }
            default: {
                return <input type="button" value="Sluit" onClick={this.closeCurrentPopup} className={`popup-btn-close popup-${state}`} />;
            }
        }
    };

    getCustomClassNames = (activeType, properties) => {
        switch (activeType) {
            case PopupTypes.LEVEL_SETTINGS: {
                switch (properties.mode) {
                    case LevelSettingsModeEnum.MAIN: {
                        return 'level-settings-main';
                    }
                    case LevelSettingsModeEnum.LEVEL_GOAL: {
                        return 'mode-level-goal';
                    }
                    case LevelSettingsModeEnum.LEVEL_VIEW: {
                        let name = 'mode-level-view';
                        if (properties.fromLevelGrid) {
                            name += ' dark-bg';
                        }
                        return name;
                    }
                    default: {
                        return '';
                    }
                } // Switch-case levelsettings mode
            } // case levelSettings
            case PopupTypes.FAILEDLOAD: {
                return 'failed-load';
            } // case publish
            case PopupTypes.NOWEBGL: {
                return 'nowebgl';
            }
            case PopupTypes.PUBLISH: {
                return 'publish-error';
            } // case publish
            case PopupTypes.LEVEL_REMOVE_WARNING: {
                return 'mode-level-remove-warning';
            }
            case undefined: {
                return 'unknown';
            }
            default: {
                return '';
            } // default
        } // Switch-case active popup type
    };

    closeCurrentPopup = () => {
        const { dispatch } = this.props;
        dispatch(CloseActivePopup());
    };

    render() {
        const { popup } = this.props;
        const { activeType, state, properties } = popup;

        const popupContent = this.getActivePopupContent(activeType, properties);

        // If popup is supposed to open something,
        // render popup with its contents and properties
        if (activeType !== PopupTypes.NONE) {
            return (
                <div className={`popup-container ${this.getCustomClassNames(activeType, properties)}`}>
                    <div className={`popup-content-container popup-${state}`}>
                        <div id={`popup-type-${activeType}`} className="popup-content">
                            {popupContent}
                            {this.getCloseButton(activeType, state)}
                        </div>
                    </div>
                </div>
            );
        }
        return '';
    }
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    popup: state.popup
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Popup);
